module.exports = __webpack_public_path__ + "static/media/Aalidhra8a1.d049bb96.jpg";